module.exports = __webpack_public_path__ + "static/media/README.c3c27fd3.md";